import slugg from "slugg";
export default slugg;
